import { upperFirst } from 'lodash';
import { CircleDollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useStore from '../../../../store';
import { LandlordBooking, TenantBooking } from '../../../../types/bookings';
import {
  StyledSection,
  StyledSectionTitle,
  StyledSectionTitleWrapper,
} from '../BookingInformation.styles';
import BookingLandlordPaymentInformation from './BookingLandlordPaymentInformation';
import BookingTenantPaymentInformation from './BookingTenantPaymentInformation';

interface BookingPaymentInformationProps {
  booking: LandlordBooking | TenantBooking;
}

const BookingPaymentInformation = ({
  booking,
}: BookingPaymentInformationProps) => {
  const { t } = useTranslation(['booking']);
  const { user } = useStore(state => ({
    user: state.user,
  }));
  return (
    <StyledSection>
      <StyledSectionTitleWrapper user={user?.type}>
        <CircleDollarSign size={20} />
        <StyledSectionTitle>
          {upperFirst(t('booking:paymentInformation'))}
        </StyledSectionTitle>
      </StyledSectionTitleWrapper>

      {user?.type === 'landlord' && (
        <BookingLandlordPaymentInformation
          proposal={booking?.pricing.proposal}
          monthlyFee={booking?.pricing.monthly_fee}
          yearlyEarnings={booking?.pricing.yearly_earnings}
        />
      )}
      {user?.type === 'tenant' && (
        <BookingTenantPaymentInformation
          bookingStage={booking?.stage}
          bookingId={booking.id}
          proposal={booking?.pricing.proposal}
          cardNumber={(booking as TenantBooking)?.card_last4}
        />
      )}
    </StyledSection>
  );
};

export default BookingPaymentInformation;
